var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C7.40194 0 0 7.40194 0 16.5C0 25.5974 7.40194 33 16.5 33C25.5974 33 33 25.5974 33 16.5C33 7.40194 25.5987 0 16.5 0ZM20.6034 17.0809H17.919V26.6488H13.9412C13.9412 26.6488 13.9412 21.4209 13.9412 17.0809H12.0503V13.6993H13.9412V11.512C13.9412 9.94546 14.6856 7.49764 17.9555 7.49764L20.9031 7.50894V10.7915C20.9031 10.7915 19.112 10.7915 18.7637 10.7915C18.4154 10.7915 17.9203 10.9657 17.9203 11.7127V13.6999H20.951L20.6034 17.0809Z",
    fill: "#9F9F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook3);
export default __webpack_public_path__ + "static/media/facebook-3.c56e6a9deda8b788c59577f3eb647003.svg";
export { ForwardRef as ReactComponent };